export const getIsBffFeatureEnabled = (): boolean =>
  !['false'].includes(import.meta.env.VITE_FEATURE_BFF ?? '');
